import { IIconProps } from "../types"

export default function IconLR2(props: IIconProps) {
  const width = props.size || props.width || 52
  const height = props.size || props.height || 87
  return (
    <svg
      {...props}
      width={width}
      height={height}
      className={props.className}
      style={props.style}
      viewBox="0 0 52 87"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.502178 7.9711C0.692178 5.7611 1.41218 4.5911 3.10218 3.6111C4.80218 2.6311 7.47218 1.8511 12.5822 1.3011C17.6922 0.751104 25.2422 0.421104 30.7422 0.451104C36.2422 0.491104 39.6922 0.881104 42.3022 1.6611C44.9022 2.4411 46.6622 3.6111 47.8622 5.6611C49.0722 7.7111 49.7222 10.6411 50.1422 14.9411C50.5622 19.2411 50.7622 24.9011 50.3722 35.3511C49.9822 45.8011 49.0022 61.0311 47.7722 69.9811C46.5322 78.9411 45.0322 81.6111 42.8822 83.3311C40.7322 85.0611 37.9422 85.8411 34.6522 86.1611C31.3622 86.4911 27.5822 86.3611 24.6522 85.5411C21.7222 84.7311 19.6422 83.2311 17.8522 81.0911C16.0622 78.9411 14.5622 76.1411 12.4822 69.5611C10.4022 62.9911 7.73218 52.6311 5.71218 43.1911C3.69218 33.7511 2.32218 25.2311 1.48218 19.3311C0.632178 13.4411 0.312178 10.1911 0.502178 7.9711Z"
        fill="#E6E6E6"
        stroke="black"
        stroke-width="0.9"
        strokeMiterlimit="2.61313"
      />
    </svg>
  )
}
